import React, { useState } from "react";
import ContentWrapper from "./ContentWrapper";
import Buttonz from "../atoms/Buttonz";
import Inputz from "../atoms/Inputz";
import { submitAccountDeletion } from "../../utils/settingAccountValidation";
import { useDispatch } from "react-redux";
import { validationPopup } from "../../redux/actions";
import CenterTitleZ from "../atoms/CenterTitleZ";

function SettingAccount({ title, icon, content }) {
  const [formData, setFormData] = useState({
    confirmDelete: "",
  });
  const [errors, setErrors] = useState({});
  const [showConfirm, setShowConfirm] = useState(false);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleDeleteClick = () => {
    setShowConfirm(true);
  };

  const handleConfirmDelete = async () => {
    const result = await submitAccountDeletion(dispatch, formData);
    if (!result.success) {
      setErrors(result.errors);
    } else {
      dispatch(
        validationPopup({
          message: "Your account has been deleted successfully.",
          type: "success",
          icon: "ok",
        })
      );
      setTimeout(() => {
        window.location = "/";
      }, 2000);
    }
  };

  return (
    <>
      {!showConfirm ? (
        <div className="form-def-box">
      <CenterTitleZ title={title} icon={icon} content={content} className="setting-profile-title" />

          <Buttonz
            iconR="horror"
            hoverR="horror"
            label="Delete Account"
            className={"lined"}
            onClick={handleDeleteClick}
          />
        </div>
      ) : (
        <div className="form-def-box">
      <CenterTitleZ title={title} icon={icon} content={content} className="setting-profile-title" />

          <Inputz
            iconL="register"
            focusL="register"
            placeholder="Type 'DELETE' to confirm"
            name="confirmDelete"
            value={formData.confirmDelete}
            onChange={handleChange}
            error={errors?.confirmDelete}
          />
          <Buttonz
            iconR="horror"
            hoverR="horror"
            label="Confirm Delete Account"
            className={"lined"}
            onClick={handleConfirmDelete}
          />
        </div>
      )}
    </>
  );
}

export default SettingAccount;
